namespace Ir.Components.Workbook.Settings.Items.FilterSetting {
    export enum FilterSettingsValueChangeTypeEnum {
        Before,
        After
    }
    export interface IFilterSettingParams {
        id: KnockoutObservable<number>;
        label: string | KnockoutObservable<string>;
        valueChangeType?: FilterSettingsValueChangeTypeEnum;
        disabled?: KnockoutObservable<boolean> | KnockoutComputed<boolean>;
        onFiltering?: (items: Array<FilterTemplate>) => Array<FilterTemplate>
        onSelected?(newValue: FilterTemplate, oldValue: FilterTemplate);
        onClear?(oldValue: FilterTemplate);
    }
    interface IViewModel {
        textBoxOptions: any;
        popoverButtonOptions: any;
        removeButtonOptions: any;
        label: any;
    }

    interface IParams {
        config: IFilterSettingParams;
    }

    export function getViewModel(this: IViewModel, params: IParams) {
        let self = this;
        self.label = params.config.label;
        if (params.config.valueChangeType === undefined) {
            params.config.valueChangeType = FilterSettingsValueChangeTypeEnum.Before;
        }

        let filter = ko.computed(function (this: KnockoutObservable<number>) {
            let id = this();
            let filter: FilterTemplate = MappingService.getFilter(id);
            return filter;
        }, params.config.id);

        let name = ko.computed(function (this: KnockoutObservable<number>) {
            let filterValue = filter();
            let nameValue = "";
            if (filterValue) {
                nameValue = filterValue.name;
            }
            return replaceBasicHtmlContent(nameValue);
        });

        self.popoverButtonOptions = {
            icon: "ms ir-find-icon",
            hint: ko.computed(function () {
                return "Choose the " + getLabel(params.config);
            }),
            disabled: params.config.disabled ?? false,
            onClick: function (e) {
                let onSelected = function (item: FilterTemplate) {
                    let oldFilter = filter();
                    if (params.config.valueChangeType === FilterSettingsValueChangeTypeEnum.Before) {
                        if (params.config.onSelected) {
                            params.config.onSelected(item, oldFilter);
                        }
                    }

                    params.config.id(item.id);

                    if (params.config.valueChangeType === FilterSettingsValueChangeTypeEnum.After) {
                        if (params.config.onSelected) {
                            params.config.onSelected(item, oldFilter);
                        }
                    }
                };

                MappingService.show({
                    type: MappingPopoverTypeEnum.Filters,
                    $target: $(e.element).siblings(".textbox-item"),
                    onSelect: onSelected,
                    title: "Mapping Filters",
                    onFiltering: params.config.onFiltering,
                });
            },
        };

        self.removeButtonOptions = {
            icon: "ms ir-clear-icon",
            hint: ko.computed(function () {
                return "Remove the " + getLabel(params.config);
            }),
            disabled: params.config.disabled ?? false,
            onClick: function (e) {
                if (params.config.valueChangeType === FilterSettingsValueChangeTypeEnum.Before) {
                    if(params.config.onClear) {
                        params.config.onClear(filter());
                    }
                }

                params.config.id(null);

                if (params.config.valueChangeType === FilterSettingsValueChangeTypeEnum.After) {
                    if(params.config.onClear) {
                        params.config.onClear(filter());
                    }
                }
            }
        };

        self.textBoxOptions = {
            value: name,
            width: "100%",
            readOnly: true,
        };
    }

    function getLabel(config: IFilterSettingParams) {
        return typeof config.label === "function" ? config.label() : config.label;
    }
}